import React, { Component } from 'react';
import { getDays, saveDayOpeningTime, saveDayClosingTime } from '../../utility/day';
import WaitForState from '../WaitForState';
import { addMessage } from '../../actions/messages';
import { withRouter } from 'react-router';
import { withUser } from '../../utility/withUser';
import { connect } from 'react-redux';
import { hasPermission } from '../../utility/account';

/**
 * Component for showing day settings.
 *
 * @extends React.Component
 */
class Days extends Component {
  /** @inheritdoc */
  constructor(props) {
    super(props);
    this.state = {
      days: null,
      doneWorking: true,
      editAllowed: null,
    }
  }

  /**
   * Handle when a day has been updated.
   */
  handleDayUpdate = (dayId, field, e) => {
    if (!this.state.editAllowed) {
      return;
    }

    var daysC = this.state.days;
    daysC[dayId][field] = e.target.value;
    this.setState({days: daysC});

    // We don't want to trigger a request every time the user touches his
    // keyboard. Only trigger when he has not done so in half a second.
    var identifier = dayId + '-' + field;
    if (this.timeouts === undefined) {
      this.timeouts = {};
    }
    if (this.timeouts[identifier] !== undefined) {
      window.clearTimeout(this.timeouts[identifier]);
    }

    this.timeouts[identifier] = window.setTimeout(() => {
      var func = saveDayClosingTime;
      if (field === 'opening_time') {
        func = saveDayOpeningTime;
      }
      this.setState({doneWorking: false});
      func(dayId, this.state.days[dayId][field], this.props.token, this.props.history, (response) => {
        if (response.status !== 200) {
          this.props.dispatch(addMessage('Fejl under gemning af dag. Prøv venligst igen senere.', 'danger'));
        }
        this.setState({doneWorking: true});
      });
    }, 500);
  }

  /**
   * Fetch permission to edit day.
   */
  fetchEditAllowedPermission = () => {
    hasPermission(this.props.user.id, "modify any day", this.props.token, this.props.history, (allowed) => {
      this.setState({editAllowed: allowed});
    });
  }

  /**
   * Fetch days.
   */
  fetchDays = () => {
    getDays(this.props.token, this.props.history, (response) => {
      if (response.status !== 200) {
        this.props.dispatch(addMessage('Fejl under hentning af dage. Prøv venligst igen senere.', 'danger'));
      }

      response.json().then((data) => {
        var items = {};
        data.items.forEach((item) => {
          items[item.id] = item;
        });
        this.setState({days: items});
      });
    });
  }

  /**
   * Get day as readable string.
   */
  getReadableDay = (day) => {
    var map = {
      monday: 'Mandag',
      tuesday: 'Tirsdag',
      wednesday: 'Onsdag',
      thursday: 'Torsdag',
      friday: 'Fredag',
      saturday: 'Lørdag',
      sunday: 'Søndag',
    }

    if (map[day] !== undefined) {
        return map[day];
    }
    return day;
  }

  /** @inheritdoc */
  componentDidMount = () => {
    this.fetchDays();
    this.fetchEditAllowedPermission();
  }

  /** @inheritdoc */
  render() {
    return (
      <div className="tab-pane fade show active" id="automessages" role="tabpanel" aria-labelledby="automessages">
        <div className="widget">
          <WaitForState keys={['doneWorking']} state={this.state} />
          <h3 className="section-heading">Åbningstider</h3>
          <WaitForState state={this.state} keys={['days']}>
            {this.state.days && Object.keys(this.state.days).map((dayId) => {
              var day = this.state.days[dayId];
              return (
              <div className="form-group" key={day.id}>
                <label>{this.getReadableDay(day.id)}</label>
                <input type="time" className="form-control" value={day.opening_time || ''} onChange={(e) => {this.handleDayUpdate(day.id, 'opening_time', e)}} disabled={this.state.editAllowed ? '' : 'disabled'} />
                <input type="time" className="form-control" value={day.closing_time || ''} onChange={(e) => {this.handleDayUpdate(day.id, 'closing_time', e)}} disabled={this.state.editAllowed ? '' : 'disabled'} />
              </div>
            )})}
          </WaitForState>
        </div>
      </div>
    );
  }
}

export default withRouter(withUser(connect()(Days)));



// WEBPACK FOOTER //
// ./src/components/Days/index.js